@if (loaded()) {
  <hyperkit-report-query-header
    [isPivot]="true"
    [category]="pivot.category"
    [parentQuery]="parentCategory"
  ></hyperkit-report-query-header>
  <hyperkit-code-block [code]="pivot.query"></hyperkit-code-block>
  <report-text-block
    title="Notes"
    variant="body"
    size="lg"
    [value]="pivot.notes"
  ></report-text-block>
} @else {
  <p>Loading…</p>
}

<!-- Display recursive pivots -->
@for (childPivot of pivot.pivots; track childPivot) {
  <report-pivot-block
    [pivot]="childPivot"
    [parentCategory]="pivot.category"
  ></report-pivot-block>
}
